import React from 'react'
import { Link } from 'gatsby-plugin-intl'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { isLightColor } from '../../../utils/colors'
import * as styles from './badge.module.scss'

export default function Badge(props) {
  const isTheColorDark = props.color && !isLightColor(props.color)

  return (
    <Link
      to={props.slug}
      className={classNames(
        'badge badge-dark rounded-pill px-4',
        { 'text-white': isTheColorDark },
        styles.badge
      )}
      style={{ borderColor: props.color, backgroundColor: props.color }}
    >
      {props.title}
    </Link>
  )
}

Badge.propTypes = {
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  color: PropTypes.string,
}
